"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createMeetingEventObserver = createMeetingEventObserver;
exports.loggerName = void 0;
var _logger = require("@studio/logger");
var _feature = require("@studio/feature.flags");
var _constants = require("@studio/constants");
var _excluded = ["meetingHistory"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var loggerName = exports.loggerName = 'chime-sdk-events';
var eventsToBeLogged = ['meetingEnded', 'videoInputSelected', 'audioInputSelected', 'meetingReconnected', 'videoInputUnselected', 'audioInputUnselected', 'receivingAudioDropped', 'sendingAudioRecovered', 'meetingStartRequested', 'meetingStartSucceeded', 'attendeePresenceReceived'];
var errorEventsToBeLogged = ['meetingFailed', 'signalingDropped', 'audioInputFailed', 'videoInputFailed', 'sendingAudioFailed', 'meetingStartFailed'];
function createMeetingEventObserver(dispatch, actions) {
  return {
    /**
     * @param {{}} attr
     * @param {string} name
     */
    eventDidReceive: function eventDidReceive(name, attr) {
      var _actions$showModal = actions.showModal,
        showModal = _actions$showModal === void 0 ? function () {} : _actions$showModal,
        _actions$showNotifica = actions.showNotification,
        showNotification = _actions$showNotifica === void 0 ? function () {} : _actions$showNotifica,
        _actions$clearNotific = actions.clearNotification,
        clearNotification = _actions$clearNotific === void 0 ? function () {} : _actions$clearNotific,
        _actions$updateMeetin = actions.updateMeetingStatus,
        updateMeetingStatus = _actions$updateMeetin === void 0 ? function () {} : _actions$updateMeetin;
      var meetingHistory = attr.meetingHistory,
        otherAttributes = _objectWithoutProperties(attr, _excluded);
      var recentMeetingHistory = meetingHistory.filter(function (_ref) {
        var timestampMs = _ref.timestampMs;
        return Date.now() - timestampMs < 5 * 60 * 1000; // Only show meeting history for the past 5 minutes
      });

      var attributes = _objectSpread(_objectSpread({}, otherAttributes), {}, {
        meetingHistory: recentMeetingHistory,
        chimeEventName: name
      });
      var allEventsToBeLogged = [].concat(eventsToBeLogged, errorEventsToBeLogged);
      if (!allEventsToBeLogged.includes(name)) {
        return;
      }
      var logMessage = "Chime: ".concat(name);
      var isError = errorEventsToBeLogged.includes(name);
      isError ? console.error(logMessage, attributes) : console.info(logMessage, attributes);
      (0, _logger.sendToDatadog)(loggerName, attributes, logMessage, isError);
      var isNetworkHealthAlerts = (0, _feature.shouldHaveFeature)('studio.networkHealthAlerts');
      if (name === 'meetingStartSucceeded') {
        dispatch(updateMeetingStatus(_constants.MEETING_STATUS.STARTED));
      }
      if (isNetworkHealthAlerts) {
        if (name === 'meetingEnded') {
          dispatch(showModal(_constants.MEETING_ENDED_MODAL));
        }
        if (name === 'meetingFailed' || name === 'meetingStartFailed') {
          var modalMessage = attributes.meetingStatus === 'SignalingBadRequest' ? 'It looks like you have been disconnected. Refresh your browser to reconnect and rejoin the meeting.' : attributes.meetingStatus;
          dispatch(showModal(_constants.MEETING_ENDED_MODAL, modalMessage));
        }
        if (name === 'receivingAudioDropped') {
          dispatch(showNotification('Your internet connection is unstable. Audio loss detected', {
            timeout: 5000,
            type: 'alert'
          }));
        }
        if (name === 'signalingDropped') {
          dispatch(showNotification('Your internet connection is unstable. Attempting to re-connect...', {
            type: 'warning',
            indefinite: true
          }));
        }
        if (name === 'meetingReconnected') {
          dispatch(clearNotification());
        }
      }
    }
  };
}